export const BASE_URL = 'https://norma.nomoreparties.space/api/';
export const WS_BASE_URL = 'wss://norma.nomoreparties.space/orders';
export const VALUE_BUN = 'bun';
export const VALUE_SAUCE = 'sauce';
export const VALUE_MAIN = 'main';
